<template>
  <div>
    <!--欢迎页-->
    <div v-if="page == 0">
      <img src="/images/wjaq/1.png?v=11" style="position: absolute; left: 0; width: 100%; top: 0; height: 100%" @click="() => {
        page = 1;
      }
        "/>
    </div>
    <!--设置页-->
    <div v-if="page == 1">
      <div style="
          background: #333437;
          position: absolute;
          left: 0;
          width: 100%;
          top: 0;
          height: 100%;
        ">
        <div style="
            background: #fff;
            border-radius: 8px;
            position: absolute;
            left: 16px;
            right: 16px;
            top: 62px;
            bottom: 92px;
            overflow: auto;
          ">
          <div style="margin: 16px 0; border-bottom: 1px solid #f0f0f0">
            <div style="font-weight: bold; font-size: 1.2em; margin: 16px">
              家庭情况配置
            </div>
            <van-field
              v-model="info.xiaoqu"
              label="小区名称"
              placeholder="请填写小区名称"
              :required="true"
            />
            <van-field
              v-model="info.address"
              label="所在位置"
              right-icon="location-o"
              placeholder="请获取位置"
              :required="true"
              type="textarea"
              @click-right-icon="getlocationpoint"
            />
            <van-field label="所在楼层">
              <template #input>
                <van-stepper v-model="info.floor" integer/>
                <span>（楼）</span>
              </template>
            </van-field>
            <van-field label="房屋面积">
              <template #input>
                <van-stepper v-model="info.area"/>
                <span>（㎡）</span>
              </template>
            </van-field>
            <van-field label="单层层高">
              <template #input>
                <van-stepper v-model="info.layerHeight"/>
                <span>（米）</span>
              </template>
            </van-field>
            <van-field label="居住总人数">
              <template #input>
                <van-stepper v-model="info.peoples" min="0" integer/>
                <span>（人）</span>
              </template>
            </van-field>
            <van-field label="老人（60岁以上）">
              <template #input>
                <van-stepper v-model="info.oldPeople" min="0" integer/>
                <span>（人）</span>
              </template>
            </van-field>
            <van-field label="小孩（6岁以下）">
              <template #input>
                <van-stepper v-model="info.children" min="0" integer/>
                <span>（人）</span>
              </template>
            </van-field>
            <van-field label="青年数（6~60岁）">
              <template #input>
                <van-stepper v-model="info.yongPeople" min="0" integer/>
                <span>（人）</span>
              </template>
            </van-field>
            <van-field v-model="info.buildYear" type="number" label="房屋修建年份" placeholder="请输入年份"/>
            <year-chose :popup-show="isShow"/>

            <van-field label="房屋使用年限">
              <template #input>
                <van-stepper v-model="info.houseYear" min="0" integer/>
                <span>（年）</span>
              </template>
            </van-field>
            <van-field label="无行动能力">
              <template #input>
                <van-stepper v-model="info.disPeoples" min="0" integer/>
                <span>（人）</span>
              </template>
            </van-field>
            <van-field label="消防知识掌握">
              <template #input>
                <van-radio-group v-model="info.knowledgeLevel">
                  <van-radio v-for="item in knowledgeLevels" :key="item" :name="item.value" style="padding-bottom: 8px">
                    {{ item.name }}
                  </van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </div>
          <div v-for="g in items" :key="g">
            <div style="font-weight: bold; font-size: 1.2em; margin: 16px">
              {{ g.caption }}
            </div>
            <van-grid column-num="3">
              <van-grid-item v-for="item in g.list" :key="item">
                <div style="text-align: center">
                  <img :src="'/images/wjaq/icons/' + item.id + '.png'" style="width: 60px; height: 60px"/>
                  <div :style="'font-size: 0.8em;' +
                    (item.num > 0 ? 'color:#ff8330' : 'color:#ccc')
                    ">
                    {{ item.name }}
                  </div>
                  <div style="margin-top: 8px">
                    <van-stepper v-model.number="item.num" step="1" input-width="30px" button-size="20px" min="0"
                                 integer/>
                  </div>
                </div>
              </van-grid-item>
            </van-grid>
          </div>
        </div>

        <div style="position: absolute; bottom: 16px; left: 16px; right: 16px">
          <div style="
              background: #ffe53b;
              font-weight: bold;
              color: #ff8330;
              font-size: 1.5em;
              border-radius: 8px;
              height: 60px;
              line-height: 60px;
              text-align: center;
            " @click="doSubmit">
            查看测试结果
          </div>
        </div>
      </div>
    </div>
    <!--结果页-->
    <div v-if="page == 2">
      <div style="
          background: #333437;
          position: absolute;
          left: 0;
          width: 100%;
          top: 46px;
          height: 100%;
          overflow: auto;
        ">
        <div style="background: #fff; border-radius: 8px; margin: 16px">
          <div style="
              background: #ffe53b;
              color: #ff8330;
              text-align: center;
              height: 60px;
              line-height: 60px;
              font-size: 1.5em;
              font-weight: bold;
              border-radius: 8px 8px 0 0;
            ">
            测试结果
          </div>
          <div style="padding: 16px">
            <div style="padding-bottom: 16px; text-align: center">
              <div style="margin-bottom: 8px; font-weight: bold">安全等级</div>
              <div v-if="result">
                <van-rate v-model="result.level" :size="25" color="#ffd21e" void-icon="star" void-color="#eee"
                          readonly/>
              </div>
            </div>
            <van-grid column-num="2" v-if="result && result.values && result.values.length > 0">
              <van-grid-item v-for="item in result.values" :key="item">
                <div style="margin-bottom: 8px; font-size: 0.8em">
                  {{ item.name }}
                </div>
                <div v-if="item.v">
                  <span style="font-weight: bold">{{ item.v }}</span>
                  <span style="font-size: 0.6em; margin-left: 5px; color: #999">
                    {{ item.unit }}
                  </span>
                </div>
                <div v-else>/</div>
              </van-grid-item>
            </van-grid>
          </div>
        </div>
        <div style="background: #fff; border-radius: 8px; margin: 16px">
          <div style="
              background: #ffe53b;
              color: #ff8330;
              text-align: center;
              height: 60px;
              line-height: 60px;
              font-size: 1.5em;
              font-weight: bold;
              border-radius: 8px 8px 0 0;
            ">
            建议
          </div>
          <div style="padding: 16px 16px 0 16px">
            <div v-if="result && result.intros && result.intros.length > 0">
              <div style="padding-bottom: 16px; font-size: 0.8em" v-for="(item, index) in result.intros" :key="item">
                {{ index + 1 }}、{{ item }}
              </div>
            </div>
            <div v-else>
              <van-empty description="没有任何建议"/>
            </div>
          </div>
        </div>
        <div style="margin: 16px">
          <div style="
              background: #ffe53b;
              font-weight: bold;
              color: #ff8330;
              font-size: 1.5em;
              border-radius: 8px;
              height: 60px;
              line-height: 60px;
              text-align: center;
            " @click="() => {
              page = 1;
            }
              ">
            再测一次
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Toast} from "vant";
import axios from "axios";
import YearChose from "@/components/YearChose.vue";

export default {
  components: {YearChose},
  data() {
    return {
      isShow: true,
      page: 0,
      dataKey: {
        1: "bigSofa",
        2: "smallSofa",
        3: "teaTable",
        4: "chair",
        5: "woodenTable",
        6: "bigBed",
        7: "smallBed",
        8: "woodenDesk",
        9: "wardrobe",
        11: "waterHeater",
        12: "fridge",
        13: "tv",
        14: "washer",
        15: "electricCooking",
        16: "gasCooking",
        17: "vrv",
        18: "computer",
        19: "waterDispenser",
        20: "woodenFloor",
        21: "woodenDoor"
      },
      info: {
        floor: 5,
        area: 100,
        layerHeight: 2.8,
        peoples: 3,
        disPeoples: 0,
        knowledgeLevel: 0,
        address: "",
        oldPeople: 0,
        children: 0,
        houseYear: 5,
        yongPeople: 0
      },
      knowledgeLevels: [
        {
          name: "很差",
          value: 0
        },
        {
          name: "一般",
          value: 1
        },
        {
          name: "专业",
          value: 2
        }
      ],
      items: [
        {
          id: 1,
          caption: "家具有",
          list: [
            {
              id: 1,
              name: "大沙发",
              price: 5000,
              weight: 738,
              num: 1
            },
            {
              id: 2,
              name: "小沙发",
              price: 2000,
              weight: 243,
              num: 0
            },
            {
              id: 3,
              name: "茶几",
              price: 1500,
              weight: 728,
              num: 1
            },
            {
              id: 4,
              name: "椅子",
              price: 800,
              weight: 250,
              num: 0
            },
            {
              id: 5,
              name: "木餐桌",
              price: 1500,
              weight: 708,
              num: 1
            },
            {
              id: 6,
              name: "大床",
              price: 3000,
              weight: 550,
              num: 1
            },
            {
              id: 7,
              name: "小床",
              price: 2000,
              weight: 350,
              num: 0
            },
            {
              id: 8,
              name: "木书桌",
              price: 1800,
              weight: 800,
              num: 0
            },
            {
              id: 9,
              name: "衣柜",
              price: 5000,
              weight: 2500,
              num: 0
            }
          ]
        },
        {
          id: 2,
          caption: "电器有",
          list: [
            {
              id: 11,
              name: "热水器",
              price: 8000,
              weight: 280,
              num: 1
            },
            {
              id: 12,
              name: "冰箱",
              price: 3000,
              weight: 378,
              num: 1
            },
            {
              id: 13,
              name: "电视",
              price: 5000,
              weight: 304,
              num: 1
            },
            {
              id: 14,
              name: "洗衣机",
              price: 2500,
              weight: 180,
              num: 1
            },
            {
              id: 15,
              name: "电炊具",
              price: 1200,
              weight: 250,
              num: 0
            },
            {
              id: 16,
              name: "燃气具",
              price: 3000,
              weight: 100,
              num: 0
            },
            {
              id: 17,
              name: "空调",
              price: 4500,
              weight: 72,
              num: 0
            },
            {
              id: 18,
              name: "电脑",
              price: 6000,
              weight: 120,
              num: 0
            },
            {
              id: 19,
              name: "饮水机",
              price: 500,
              weight: 560,
              num: 0
            }
          ]
        },
        {
          id: 3,
          caption: "装修情况",
          list: [
            {
              id: 20,
              name: "木地板(㎡)",
              price: 80,
              weight: 200,
              num: 0
            },
            {
              id: 21,
              name: "木门(扇)",
              price: 800,
              weight: 205,
              num: 0
            }
          ]
        }
      ],
      result: null
    };
  },
  methods: {
    //获取经纬度
    getlocationpoint: function () {
      let that = this;
      let latitude = null;
      let longitude = null;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          function (position) {
            latitude = position.coords.latitude;//获取纬度
            longitude = position.coords.longitude;//获取经度
            that.info.latitude = latitude;
            that.info.longitude = longitude;
            console.log(latitude, longitude);
            //获取地理位置
            Toast.loading({
              message: "获取中..."
            });
            axios.get("/api/getLocation/" + longitude + "," + latitude).then(function ({data}) {
              // handle success
              console.log("--------------------", data);
              that.info.address = data?.regeocode.formatted_address;
            }).catch(function (err) {
              console.log("--------------------", err);
            }).finally(() => {
              Toast.clear();
            });

          });
      } else {
        Toast("不支持定位功能");
      }
    },

    doSubmit() {
      var that = this;
      //      表单数据判断
      if (!that.info.xiaoqu) {
        Toast.fail("请输入小区名称");
        return false;
      }
      if (!that.info.address) {
        Toast.fail("请获取定位");
        return false;
      }

      var allFuhe = 0; //总负荷
      var eNum = 0; //电器数量
      var ranqi = false;
      var prices = 0; //总价格
      that.items.forEach((g) => {
        g.list.forEach((item) => {
          if (item.id == 16) {
            //燃气
            ranqi = item.num > 0;
          }
          allFuhe += item.num * item.weight;
          if (g.id == 2) {
            //如果是电器组
            eNum += item.num;
          }
          prices += item.num * item.price;
        });
      });
      var midu = allFuhe / that.info.area; //负荷密度
      var taoTime = that.info.floor * 6; //逃生时间
      if (that.info.disPeoples > 0) {
        taoTime = taoTime * (that.info.disPeoples * 3);
      }
      var starLevel = 3;
      if (midu > 200) {
        starLevel = 2;
      }
      if (midu > 300) {
        starLevel = 1;
      }
      if (midu < 100) {
        starLevel = 4;
      }
      if (midu < 50) {
        starLevel = 5;
      }
      that.result = {
        level: starLevel,
        values: [
          {
            name: "火灾负荷",
            unit: "fw",
            v: allFuhe
          },
          {
            name: "负荷密度",
            unit: "v/㎡",
            v: midu.toFixed(2)
          },
          {
            name: "火灾概率",
            unit: "%",
            v: ""
          },
          {
            name: "燃烧时长",
            unit: "小时",
            v: "≈ " + (midu / 15).toFixed(2)
          },
          {
            name: "逃生时间",
            unit: "秒",
            v: "≈ " + parseInt(taoTime)
          },
          {
            name: "火灾损失",
            unit: "万元",
            v: "≈ " + (prices / 10000).toFixed(2)
          }
        ],
        intros: [
          "严禁在可燃物较多的地方用明火玩游戏，家中打火机和火柴应放在儿童拿不到的地方。"
        ]
      };
      if (midu >= 250) {
        that.result.intros.push(
          "清理无用杂物，保证逃生通道畅通无阻，切不可随手堆放杂物或将通道设闸上锁，以便紧急时能安全迅速地通过。"
        );
      }
      if (that.info.floor >= 10) {
        that.result.intros.push(
          "提前了解避难层位置，如果起火时不能安全逃到地面，应往避难层逃生，在避难层等待救援。"
        );
      }
      if (that.info.disPeoples > 0) {
        that.result.intros.push("带有行动不便人员逃生时需要注意逃生时间。");
      }
      if (eNum > 0) {
        that.result.intros.push(
          "不私拉乱拉电线和插座正确使用电器设备、不超负荷用电、及时更换维修老化电器设备和线路。"
        );
        that.result.intros.push(
          "取暖注意安全用火用电，及时清理周围可燃物。出门时请不要忘记关闭电源燃气开关。"
        );
      }
      if (eNum >= 4) {
        that.result.intros.push("请随时注意用电安全。");
      }
      if (ranqi) {
        that.result.intros.push(
          "定期对燃气管道进行检查。不能用明火查漏,可以用肥皂液查漏。一旦发生燃气泄漏,要迅速关闭气源阀门,打开门窗通风。严禁现场拨打手机,触动电源开关和使用明火。"
        );
      }
      if (that.info.knowledgeLevel == 0) {
        that.result.intros.push("加强消防知识培训。");
      }
      if (that.info.knowledgeLevel == 1) {
        that.result.intros.push("巩固消防安全知识。");
      }
      //数据提交
      Toast.loading({
        message: "计算中...",
        duration: -1
      });
      let dqData = that.getDataList(that.items);

      axios.post("/api/saveData", {
        ...that.info,
        ...dqData,
        "result": that.result
      }).then(({data}) => {
        Toast.clear();
        console.log("-----------res---------", data);
        if (data.code == 0) {
          Toast.fail(data.msg);
          return false;
        }
        that.page = 2;
      });
    },

    getDataList(data) {
      let nn = {};
      let that = this;
      data.forEach((item) => {
        item.list.forEach((item2) => {
          let tmpKey = that.dataKey[item2.id];
          nn[tmpKey] = item2.num;
        });
      });
      return nn;
    }
  },
  mounted() {
  }
};
</script>

<style>
.van-icon-location-o {
  font-size: 28px !important;
}
</style>
